export const EVENTS = {
  MOVE_TO_NEXT_STEP: 'move_to_next_step',
  APP_LOADED: 'app_loaded',
  PUBLISH_MODAL_OPENED: 'publish_modal_opened',
  PUBLISH_MODAL_CLOSED: 'publish_modal_closed',
  PUBLISH_TO_WEBSITE_CLICK: 'publish_to_website_click',
  SHARE_ON_SOCIAL_CLICK: 'share_on_social_click',
  PUBLISH_WITH_CARD_TOLSTOY_CLICK: 'publish_with_card_tolstoy_click',
  PUBLISH_EMBED_CARD_CLICK: 'publish_with_tolstoy_click',
  DOWNLOAD_MODAL_OPENED: 'publish_modal_opened',
  DOWNLOAD_MODAL_CLOSED: 'publish_modal_closed',
  GO_TO_TOLSTOY_AI_VIDEO_LIBRARY: 'go_to_tolstoy_ai_video_library',
  GO_TO_TOLSTOY_SHOP: 'go_to_tolstoy_shop',
  GET_TOLSTOY_TO_PUBLISH_ON_WEBSITE: 'get_tolstoy_to_publish_on_website',
  GET_TOLSTOY_TO_PUBLISH_ON_SHOP: 'get_tolstoy_to_publish_on_shop',
  PUBLISH_TO_SOCIAL_PLATFORM: 'publish_to_social_platform',
  PUBLISH_DOWLOAD: 'publish_dowload',
  BEST_SELLING_PRODUCT_CLICK: 'best_selling_product_click',
  ADD_VIDEO_TO_MY_TOLSTOY: 'Add video to my Tolstoy',
  REMOVE_VIDEO_FROM_MY_TOLSTOY: 'Remove video from my Tolstoy',
  PUBLISH_ON_WEBSITE_WITH_TOLSTOY: 'publish_on_website_with_tolstoy',
  PUBLISH_ON_SHOP_WITH_TOLSTOY: 'publish_on_shop_with_tolstoy',
  FEATURE_ON_SHOP_CLICK: 'feature_on_shop_click',
  PUBLISH_IN_EMAIL_WITH_TOLSTOY: 'publish_in_email_with_tolstoy',
  GET_TOLSTOY_TO_PUBLISH_IN_EMAIL: 'get_tolstoy_to_publish_in_email',
  PUBLISH_TO_EMAIL_FLOW_CLICK: 'publish_to_email_flow_click',
};
